<template>
	<!-- 常见问题 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">常见问题</p>
				</div>
			</div>
		</van-sticky>
		<div class="qjylBoxNum">
			<div class="qjylNum" @click="jumpUrlwtjd(item.id)" v-for="(item,index) in wtList" :key="index">
				<span>{{item.title}}</span>
				<span class="plNum"><img src="../../assets/img/rightArr.png" alt=""></span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				wtList:[]
			}
		},
		created() {
			this.problem_list()
		},
		methods: {
			back() {
				this.$router.push('/set')
			},
			jumpUrlwtjd(data){
				this.$router.push({path: '/wtjd',query:{id: data}})
			},
			problem_list(){
				this.$axios.post(this.$api.problem_list).then(res => {
					console.log(res)
					this.wtList = res.data.data
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.qjylBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.tabbar {
			display: flex;
			padding: 0 15%;
			line-height: 80px;
			span {
				flex: 1;
				text-align: center;
				font-size: 30px;
				/*px*/
				color: #1f1f1f;
			}
		
			span.active {
				color: #ff4081;
			}
		}
		
		.qjylBoxNum {
			padding: 0 16px;
			background-color: #fff;
			padding-top: 30px;
			//我的琼浆玉露
			.qjylNum {
				margin-bottom: 20px;
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				line-height: 80px;
				padding: 20px 30px;
				display: flex;
				font-weight: 400;
				color: #000000;
				font-size: 30px;/*px*/
				height: 80px;
				overflow: hidden;
				span:first-of-type{
					flex: 1;
				}
				span:last-child{
					width: 10%;
					text-align: right;
					img{
						width: 50px;
						vertical-align: middle;
					}
				}
			}
		}
		
	}

</style>
